import { useEffect, useState } from 'react';
import { OidcSecure, useOidcAccessToken } from '@axa-fr/react-oidc';
import axios from 'axios';
import { useNavigate } from "react-router";
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Stack, Snackbar, Alert } from '@mui/material';


const baseURL = process.env.REACT_APP_BASE_URL;

export const FamsLogin = () => {
    let navigate = useNavigate();
    const { accessToken, accessTokenPayload } = useOidcAccessToken();
    const [loading, setLoading] = useState(false);
    const [notFoundMsg, setNotFoundMsg] = useState(false);

    useEffect(() => {
        if (accessToken) {
            loginUser();
        }
    }, [accessToken])

    const loginUser = () => {
        setLoading(true);
        const headers = {
            'Authorization': accessToken ? `Bearer ${accessToken}` : '',
            "content-type": "application/json"
        }
        axios.get(`${baseURL}/famsauth`, {
            headers: headers
        })
            .then((res) => {
                if (res?.status === 200) {
                    setLoading(false);
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('refreshToken', res.data.refreshToken);
                    const jwt: any = res.data.token;
                    let labUserCheck: any = jwt ? JSON.parse(atob(jwt.split('.')[1])) : null;
                    if (labUserCheck) {
                        const isInternalUser = labUserCheck.UserType === 'Internal';

                        const hasPermission =
                            labUserCheck.Permission && labUserCheck.Permission.length > 0;

                        if (!hasPermission) {
                            navigate('/error');
                            return;
                        }

                        const hasAddUserPermission =
                            labUserCheck.Permission.includes('AddUser') ||
                            labUserCheck.Permission.includes('ManageClientUsers');

                        const hasOfficeAdminPermission =
                            labUserCheck.Permission.includes('ReviewOnboardRequest') ||
                            labUserCheck.Permission.includes('ActionOnboardRequest');

                        const hasDispatcherPermission =
                            labUserCheck.Permission.includes('ViewContainerOrder') ||
                            labUserCheck.Permission.includes('EditContainerOrder');

                        if (isInternalUser && hasAddUserPermission) {
                            navigate('/home/admin');
                        } else if (isInternalUser && !hasAddUserPermission && hasOfficeAdminPermission) {
                            navigate('/home/new-client-request');
                        } else if (isInternalUser && hasDispatcherPermission) {
                            navigate('/home/orderHistory');
                        } else {
                            navigate('/home/viewQuote');
                        }
                    }
                    setNotFoundMsg(false);
                }
            })
            .catch(function (error) {
                if (error?.response?.status === 404) {
                    setLoading(false);
                    setNotFoundMsg(true);
                    localStorage.clear();
                    setTimeout(() => {
                        sessionStorage.clear();
                        window.location.assign('/');
                    }, 2000);
                }
            });
    }

    return (
        <>
            <OidcSecure>
                <Box sx={{ margin: '0', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    {loading ? <CircularProgress /> : null}
                </Box>
            </OidcSecure>
            <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
                <Snackbar open={notFoundMsg} autoHideDuration={6000} onClose={() => setNotFoundMsg(false)}>
                    <Alert severity="error" onClose={() => setNotFoundMsg(false)}><b>User not found!</b></Alert>
                </Snackbar>
            </Stack>
        </>
    )
}
